import CryptoJS from "crypto-js/crypto-js";
// 默认的 KEY 与 iv 如果没有给
const key = CryptoJS.enc.Utf8.parse("IDiPndAkXt37ZpeS"); //""中与后台一样  密码
const iv = CryptoJS.enc.Utf8.parse("3a07c4z62efx8fq6"); //""中与后台一样  偏移量
/**
 * AES加密 ：字符串 key iv  返回base64
 */
export const cryptoEncrypt = (word) => {
  const srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = "";

  encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
};

/**
 * AES 解密 ：字符串 key iv  返回base64
 *  */
export function Decrypt(word) {
  let base64 = CryptoJS.enc.Hex.parse(word);
  let src = CryptoJS.enc.Base64.stringify(base64);

  var decrypt = CryptoJS.AES.decrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}
